// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3RTom","rightAdornment":"Header_rightAdornment__3Iy36"};